<div class="page-actions">
  <dv-button
    [isSelectedStateActive]="true"
    icon="tree"
    [selected]="isTreeViewActive()"
    (click)="
      changeViewUrl(
        activeView() === assetViewType.TreeView
          ? assetViewType.RegularView
          : assetViewType.TreeView
      )
    "></dv-button>
  <dv-button
    color="primary"
    icon="add"
    (click)="onCreateClick()"
    routerLink="new/information"
    queryParamsHandling="preserve"
    [disabled]="(canAddAsset$ | async) === false">
    {{ 'General.Assets' | translate | uppercase }}
  </dv-button>
  <dv-button
    (click)="onShowAllAssetsClick()"
    [disabled]="(canSeeMap$ | async) === false || disableMapBtn()">
    {{ 'Assets.ShowAllAssets' | translate | uppercase }}
  </dv-button>
</div>
<dv-vertical-splitter
  [splitterStatus]="splitterStatus()"
  [isResizableSideOpenable]="isResizableSideOpenable()"
  [resizableSide]="resizableSide.Right"
  id="assets-vertical-splitter">
  <div left-side>
    <app-assets-grid
      [activeView]="activeView()"
      (splitterStatusChange)="onSplitterStatusChange($event)"></app-assets-grid>
  </div>
  <div right-side>
    <router-outlet />
  </div>
</dv-vertical-splitter>

<ng-template #menuPanelTemplate>
  <app-timed-marker-map-menu-panel
    [mapSetting]="mapSetting"
    (autoRefreshClicked)="onAutoRefreshClicked($event)"
    (autoZoomFitClicked)="onAutoZoomFitClicked($event)"
    (groupMarkersClicked)="onGroupMarkersClicked($event)">
  </app-timed-marker-map-menu-panel>
</ng-template>
